module.exports = __webpack_public_path__ + "img/eyelashes.13a1e723.svg";